












































import { Component, Prop, Emit, Vue, Watch, Ref } from 'vue-property-decorator';
import { TableType } from './types';

import { ElTable } from 'element-ui/types/table';

/**
 * 具备双重表头，表格，分页
 */
@Component({})
export default class Table extends Vue {
  @Ref('tableEl') readonly tableEl!: ElTable;

  @Prop({ default: 'normal' })
  type: 'normal' | 'dark'
  @Prop({ type: Boolean, default: false })
  header: boolean;
  @Prop()
  headerTitle: string;
  @Prop({ default: [] })
  data!: TableType[];
  @Prop()
  tableClass: string;
  // 表格多选
  @Prop({ type: Boolean, default: false })
  selection: boolean;
  // 表格展开
  @Prop({ type: Boolean, default: false })
  expand: boolean;
  // 表格分页
  @Prop({ type: Boolean, default: false })
  pagination: boolean;
  @Prop()
  paginationClass: string;
  @Prop()
  total!: number;
  @Prop({ default: 10 })
  pageSize!: number;
  @Prop({ default: 1 })
  pageNo!: number;

  currentPage: number = this.pageNo;

  @Watch('pageNo')
  pageNoChange(n) {
    this.currentPage = n;
  }

  @Emit()
  currentPageChange() {
    return this.currentPage;
  }
}
